import { render } from "./AlertDetails.vue?vue&type=template&id=18def53c&scoped=true"
import script from "./AlertDetails.vue?vue&type=script&lang=js"
export * from "./AlertDetails.vue?vue&type=script&lang=js"

import "./AlertDetails.vue?vue&type=style&index=0&id=18def53c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18def53c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QTable,QTd});
